export default __webpack_public_path__ + "static/media/largelogo.cea58660.png";